import React from 'react';
import * as _ from 'lodash';
import { FieldMasters } from '../../../services/FieldMasters';
import {
  getErrorMessage,
  MASTER_TYPE,
} from '../../../pages/common/MasterParts.jsx';
import { FormElement } from '../../CommonFormComponents';
import SessionStorageService from '../../../services/utilities/SessionStorageService.js';
import DropdownSelector from '../DropdownSelector.jsx';

// 揚重機のbase_id
const CRANE_BASE_ID = 1;

// 機材のbase_id
const MACHINE_BASE_ID = 2;

/**
 * @description * 機械分類(中), 機械分類(小), 仕様分類ドロップダウン
 *              機材マスタ登録、編集画面で使用、揚重機マスタ登録、編集画面で使用
 */
export class FieldMasterItemsDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      api: null,
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.params = {};

    this.onChange = this.props.onChange.bind(this);
    this.onBlur = this.props.onBlur.bind(this);
    this.fixedOptions =
      this.props.name !== 'machine_fuel_id'
        ? [
            {
              id: '0',
              name: 'その他', //「その他」表示
            },
          ]
        : undefined;
  }

  componentDidMount() {
    // メッセージ, APIの設定など
    this.setup();
  }

  UNSAFE_componentWillUpdate(nextProps) {
    // メイン元請の会社IDを取得するため、field_idをパラメータで渡す
    const field_id = SessionStorageService.getFieldId();
    // 親からドミノ式に行う処理
    // 「機械分類(小)」の時、
    if (this.props.name === 'small_machine_id') {
      // 「機械分類(中)」の変化を見る
      const base_id = nextProps.formValues.middle_machine_id;

      if (
        !_.isUndefined(base_id) &&
        base_id !== null &&
        this.params.base_id !== base_id
      ) {
        this.params = {
          base_id,
          field_id,
        };
      }
    }

    // 「仕様分類」の時、
    if (this.props.name === 'spec_id') {
      // 「機械分類(小)」の変化を見る
      const machine_id = nextProps.formValues.small_machine_id;

      if (
        !_.isUndefined(machine_id) &&
        machine_id !== null &&
        this.params.machine_id !== machine_id
      ) {
        this.params = {
          machine_id,
          field_id,
        };
      }
    }
  }

  /**
   * 選択プルダウンのメッセージ & API
   *
   * @memberof FieldMasterItemsDropdown
   */
  setup() {
    let message = '';
    this.params = {
      field_id: SessionStorageService.getFieldId(),
    };
    let api = _.cloneDeep(this.state.api);
    switch (this.props.name) {
      case 'middle_machine_id':
        message = '機械分類(中)';
        api = FieldMasters.getMachinesList;
        this.entitiesKey = 'machines';

        let baseID = 0;
        if (this.props.masterType === MASTER_TYPE.CRANE) {
          baseID = CRANE_BASE_ID;
        } else if (this.props.masterType === MASTER_TYPE.MACHINE) {
          baseID = MACHINE_BASE_ID;
        }

        this.params['base_id'] = baseID;
        break;
      case 'small_machine_id':
        message = '機械分類(小)';
        // ※機械分類(中)とAPIは同じ
        api = FieldMasters.getMachinesList;
        // APIの結果を取得するためのキー
        this.entitiesKey = 'machines';
        break;
      case 'spec_id':
        message = '仕様分類';
        api = FieldMasters.getMachineSpecsList;
        this.entitiesKey = 'machine_specs';
        break;
      case 'machine_fuel_id':
        message = '油種';
        api = FieldMasters.getMachineFuelsList;
        this.entitiesKey = 'machine_fuels';
        break;
    }

    // プルダウンのメッセージ部分
    this.message = `${message}を選択`;
    this.setState({ api });
  }

  render() {
    return (
      <FormElement
        validate={getErrorMessage(this.props.errors, this.props.name)}
      >
        {this.state.api && (
          <DropdownSelector
            label={this.message}
            selectorName={this.props.name} // バリデーションでも使う名前
            api={this.state.api}
            apiParams={this.params}
            selectedValues={
              _.isNull(this.props.value) ? '' : String(this.props.value)
            }
            selectedName={this.props.valueName}
            keyName='name'
            valueName='id'
            apiBindDataKey={this.entitiesKey}
            onSelect={(name, value, valueName) => {
              this.onChange({ target: { name, value, valueName } });
            }}
            multiple={false}
            dropdownSelectStyle={{ width: '238px' }}
            strictEqual={true}
            apiSearchKey='name'
            onClose={() => this.onBlur({ target: { name: this.props.name } })}
            fixedOptions={this.fixedOptions}
            key={this.props.resetKey}
          />
        )}
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/MasterItems.jsx